import { TrackingEventIds } from "./../../../tracking/constants/TrackingEventIds";
import { error } from "../../../logging/error";
import { ClientFunnelGameStates } from "../../../tracking/clientFunnel/ClientFunnelGameStates";


export class TrackingVerificationPatternGenerator {
    public static CLASSIC_STANDARD_PATTERN: string = "CLASSIC_STANDARD_PATTERN";
    public static CLASSIC_FIRST_INSTANCE_SSO_PATTERN: string = "CLASSIC_FIRST_INSTANCE_SSO_PATTERN";
    public static CLASSIC_FIRST_INSTANCE_WWW_PATTERN: string = "CLASSIC_FIRST_INSTANCE_WWW_PATTERN";
    public static CLASSIC_FIRST_INSTANCE_LP_PATTERN: string = "CLASSIC_FIRST_INSTANCE_LP_PATTERN";

    public static getPattern(trackingCase: string): any[] {

        let trackingPattern: any[] = TrackingVerificationPatternGenerator.standardPattern;

        switch (trackingCase) {
            case TrackingVerificationPatternGenerator.CLASSIC_STANDARD_PATTERN:
                break;

            case TrackingVerificationPatternGenerator.CLASSIC_FIRST_INSTANCE_WWW_PATTERN:
                trackingPattern = trackingPattern.concat(TrackingVerificationPatternGenerator.firstSessionStandardPattern, TrackingVerificationPatternGenerator.firstInstanceWWWCase);
                break;

            case TrackingVerificationPatternGenerator.CLASSIC_FIRST_INSTANCE_SSO_PATTERN:
                trackingPattern = trackingPattern.concat(TrackingVerificationPatternGenerator.firstSessionStandardPattern, TrackingVerificationPatternGenerator.firstInstanceSSOCase);
                break;

            case TrackingVerificationPatternGenerator.CLASSIC_FIRST_INSTANCE_LP_PATTERN:
                trackingPattern = trackingPattern.concat(TrackingVerificationPatternGenerator.firstSessionStandardPattern);
                break;

            default:
                error("Unknown tracking pattern!");
                break;
        }

        return trackingPattern;
    }

    public static get standardPattern(): any[] {
        return [
            TrackingEventIds.CLIENT_LOAD,
            TrackingEventIds.IMPRESSION
        ];
    }

    public static get firstSessionStandardPattern(): any[] {
        return [
            TrackingEventIds.WORLD_ASSIGNMENT,
            TrackingEventIds.CONNECTION,
            TrackingEventIds.CONNECTION,
            TrackingEventIds.CONNECTION,

            ClientFunnelGameStates.LOADING_CIRCLE,
            ClientFunnelGameStates.FIRST_GAME_SCREEN,
            ClientFunnelGameStates.LOADING_BAR,
            ClientFunnelGameStates.NETWORK_XML_START,
            ClientFunnelGameStates.NETWORK_XML_END,
            ClientFunnelGameStates.LANG_XML_START,
            ClientFunnelGameStates.LANG_XML_END,
            ClientFunnelGameStates.ITEM_XML_START,
            ClientFunnelGameStates.ITEM_XML_END,
            ClientFunnelGameStates.ASSETS_START,
            ClientFunnelGameStates.ASSETS_END,
            ClientFunnelGameStates.GAME_SWF_LOADED,
            ClientFunnelGameStates.SERVER_CONNECT,
            ClientFunnelGameStates.SERVER_CONNECT_SUCCESS,
            ClientFunnelGameStates.VERSION_CHECK_SEND,
            ClientFunnelGameStates.GAME_JOINED
        ];
    }

    public static get firstInstanceWWWCase(): any[] {
        return [
            ClientFunnelGameStates.ENTER_NAME,
            ClientFunnelGameStates.ENTER_EMAIL,
            ClientFunnelGameStates.ENTER_PASSWORD,
            ClientFunnelGameStates.CLICK_REGISTER_WITH_DATA,
            ClientFunnelGameStates.REGISTERED
        ];
    }

    public static get firstInstanceSSOCase(): any[] {
        return [
            ClientFunnelGameStates.CLICK_REGISTER_WITH_DATA_SSO,
            ClientFunnelGameStates.REGISTERED
        ];
    }
}

